import {
  SESSION_TIMEOUT,
  SHOW_SESSION_TIMEOUT_DIALOG,
  HIDE_SESSION_TIMEOUT_DIALOG,
  SET_SESSION_USER_ID,
  RESTART_SESSION,
  SESSION_LOGGED_OUT,
} from '@xmatters/redux/actions/session';

import { GET_INFO_SUCCESS } from 'actions/currentOrganization';

import { GET_PERSON_SUCCESS } from 'actions/loggedInUser';

import {
  GET_SETTINGS_SUCCESS,
  UPDATE_SETTINGS_SUCCESS,
} from 'actions/settings';

import moment from 'moment-timezone';

const defaultState = {
  timeout: false,
  showWarning: false,
  time: null,
  clientSession: {
    willRefresh: false,
    nextRefresh: null,
    expiresAt: null,
    maxSessionDuration: null,
    reportingPagesExcluded: null,
    isSamlEnabled: false,
    userId: null,
  },
};

export default function session(state = defaultState, action) {
  const { payload, type } = action;

  const updatedSettings = () => {
    if (!payload?.general) {
      // General settings did not update, no new changes to consider. Only other settings were updated:
      return state;
    }

    const { maxSessionDuration, reportingPagesExcluded } = payload.general;
    return {
      ...state,
      clientSession: {
        ...state.clientSession,
        reportingPagesExcluded,
        maxSessionDuration,
        expiresAt: moment().add(maxSessionDuration, 'minutes').format(),
        nextRefresh: moment().add(maxSessionDuration, 'minutes').format(),
      },
    };
  };

  switch (type) {
    case SESSION_TIMEOUT:
      return {
        ...state,
        timeout: true,
      };
    case SHOW_SESSION_TIMEOUT_DIALOG:
      return {
        ...state,
        showWarning: true,
        time: payload,
      };
    case HIDE_SESSION_TIMEOUT_DIALOG:
      return {
        ...state,
        showWarning: false,
      };
    case RESTART_SESSION:
      return {
        ...state,
        clientSession: {
          ...state.clientSession,
          isLoggedOut: false,
        },
      };
    case SESSION_LOGGED_OUT:
      return {
        ...state,
        clientSession: {
          ...state.clientSession,
          isLoggedOut: true,
        },
      };
    case GET_INFO_SUCCESS:
      return {
        ...state,
        clientSession: {
          ...state.clientSession,
          isSamlEnabled: payload?.samlEnabled,
        },
      };
    case UPDATE_SETTINGS_SUCCESS:
      return updatedSettings();
    case GET_SETTINGS_SUCCESS:
      return updatedSettings();
    case SET_SESSION_USER_ID:
      return {
        ...state,
        clientSession: {
          ...state.clientSession,
          userId: payload,
        },
      };
    case GET_PERSON_SUCCESS:
      return {
        ...state,
        clientSession: {
          ...state.clientSession,
          userId: payload.id,
        },
      };
    default:
      return state;
  }
}
